import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-two-page',
  templateUrl: './features-two-page.component.html',
  styleUrls: ['./features-two-page.component.scss']
})
export class FeaturesTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
